import React from "react";
import propTypes from "prop-types";

import "./Currency.scss";
import { createDataAttributes } from "../../utilities";

const isNegative = number => Math.sign(number) === -1;

const asFloat = amount => {
  const result = parseFloat(amount, 10);
  return result ? result : 0.0;
};

const Currency = ({
  amount,
  nanIsZero = false,
  includeDecimals = true,
  dataAttrib
}) => {
  const result = asFloat(amount);

  let amountAsCurrency = Number(Math.abs(result)).toLocaleString("en", {
    style: "currency",
    currency: "USD"
  });

  if (!nanIsZero && isNaN(parseFloat(amount))) {
    amountAsCurrency = "";
  } else if (!includeDecimals) {
    amountAsCurrency = amountAsCurrency.split(".")[0];
  }

  return isNegative(amount) ? (
    <span className="currency--negative" {...createDataAttributes(dataAttrib)}>
      ({amountAsCurrency})
    </span>
  ) : (
    <span {...createDataAttributes(dataAttrib)}>{amountAsCurrency}</span>
  );
};

Currency.propTypes = {
  nanIsZero: propTypes.bool,
  amount: propTypes.any,
  includeDecimals: propTypes.bool,
  dataAttrib: propTypes.arrayOf(Object)
};

export default Currency;
